import { STRINGS } from '@tm/shared'
import { trackEvent } from '../analytics/plausible.js'

export function mountMobileToolbar(hostEl, workspace) {
  if (!window.matchMedia('(max-width: 768px)').matches) return

  hostEl.innerHTML = `
    <div class="tm-blockly-toolbar" role="toolbar" aria-label="Kontrol workspace">
      <button type="button" data-action="play" aria-label="${STRINGS.play}" class="tm-toolbar-primary">
        ▶ ${STRINGS.play}
      </button>
      <button type="button" data-action="zoom-out" aria-label="${STRINGS.toolbarZoomOut}">➖</button>
      <button type="button" data-action="zoom-reset" aria-label="${STRINGS.toolbarZoomReset}">🎯</button>
      <button type="button" data-action="zoom-in" aria-label="${STRINGS.toolbarZoomIn}">➕</button>
      <button type="button" data-action="center" aria-label="${STRINGS.toolbarCenter}">🧭</button>
      <button type="button" data-action="clear" aria-label="${STRINGS.toolbarClearAll}" class="tm-toolbar-danger">🗑️</button>
    </div>
  `

  hostEl.addEventListener('click', (e) => {
    const action = e.target?.dataset?.action
    if (!action) return

    const isMobile = window.matchMedia('(max-width: 768px)').matches

    switch (action) {
      case 'play':
        hostEl.dispatchEvent(new CustomEvent('play_requested', { bubbles: true }))
        trackEvent('play_requested', { via: 'toolbar' })
        break
      case 'zoom-in':
        workspace.zoomCenter(1.2)
        break
      case 'zoom-out':
        workspace.zoomCenter(1 / 1.2)
        break
      case 'zoom-reset':
        workspace.setScale(isMobile ? 0.85 : 1.0)
        workspace.scrollCenter()
        break
      case 'center':
        workspace.scrollCenter()
        break
      case 'clear':
        if (workspace.getTopBlocks(false).length === 0) return
        if (!window.confirm('Hapus semua blok?')) return
        workspace.clear()
        trackEvent('workspace_cleared', {})
        break
    }
  })
}
